export const PLACES_RETURN_MATERIALS = [
    {
        id: 'Bodega Central',
        name: "Bodega Central"
    },
    {
        id: 'Proyecto',
        name: 'Seleccionar un proyecto'
    }
]

export const PLACE_RETURN_PROJECT_ID = 'Proyecto';

export const MATERIAL_REQUEST_RETURN_STATUS_LIST = {
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado'
}

export const REQUEST_MATERIAL = "SOLICITUD DE MATERIALES"
export const REQUEST_MATERIAL_URGENT = "SOLICITUD DE MATERIAL URGENTE"

export const TYPE_REQUESTS = [
    {
        value: 1,
        name: REQUEST_MATERIAL
    },
    {
        value: 2,
        name: REQUEST_MATERIAL_URGENT
    }
]